<template>
  <div class="manual-wrapper">
    <div class="body">
      <h2>Kako dodati novog korisnika blagajne?</h2>
      <h6>
        Da biste vodili blagajnu Vaše zajednice potrebno je da dodate sve
        korisnike blagajne za koje želite da vodite blagajnu. Korisnici
        <b>mogu, ali i ne moraju imati</b> Moj Komšija mobilnu aplikaciju.
      </h6>
      <h6>
        Više korisnika odjednom možete dodati klikom na dugme
        <i>"Grupno dodavanje korisnika blagajne"</i>
      </h6>
      <!-- <h6>
        Korisnike blagajne možete dodati klikom da dugmiće "Novi korisnik
        blagajne" ili "Grupno dodavanje korisnika blagajne".
      </h6>-->
      <hr />
      <h5>
        Dodavanje korisnika koji
        <b>imaju</b> Moj Komšija mobilnu aplikaciju
      </h5>
      <h6>
        Ukoliko korisnik blagajne koga dodajte ima Moj Komšija mobilnu
        aplikaciju i član je zajednice koju vodite, možete ga povezati sa
        korisnikom blagajne kojeg kreirate.
        <br />- Neophodno je samo da klikom na odgovarajuće polje iz liste stanara odaberete željenog stanara.
        <br />- Ostala polja će se automatski popuniti (možete da ih i izmenite ako želite).
        <br />- Nakon uspešnog dodavanja, stanaru je iz mobilne aplikacije omogućen
        pregled njegovog stanja, stanja zajednice, kao i pregled svih
        njegovih računa i transakcija.
      </h6>
      <hr />
      <h5>
        Dodavanje korisnika koji
        <b>nemaju</b> Moj Komšija mobilnu aplikaciju
      </h5>
      <h6>Ukoliko stanar nema Moj Komšija mobilnu aplikaciju, a želite da vodite blagajnu i za njega neophodno je da popunite sva odgovarajuća polja i klikom na odgovarajuće dugme na dnu potvrdite unos.</h6>
      <h6>
        Korisnici blagajne se takođe mogu naknadno povezati klikom na dugme
        <strong>izmeni</strong> u listi svih korisnika blagajne. Nakon toga je
        potrebno u polju poveži sa stanarom izabrati sa kojim se članom povezuje
        korisnik. Klikom na dugme izmeni se promene čuvaju i korisnik je tada
        povezan sa članom.
      </h6>
      <hr />
      <h6>
        <b>Bitna napomena</b>
      </h6>
      <h6>
        Ukoliko korisnik koga dodajete poseduje više posebnih delova, možete ih dodati klikom na dugme "Dodaj još jedan
        poseban deo".
        <strong>
          Svaki poseban deo koji dodate ovim putem posmatra se kao
          poseban korisnik blagajne.
        </strong>
      </h6>
      <!-- <h6>
        Ukoliko korisnik blagajne koga dodajte ima Moj Komšija mobilnu
        aplikaciju i član je zajednice koju vodite, možete ga povezati sa
        korisnikom blagajne kojeg kreirate. Ukoliko je korisnik povezan sa
        članom članom aplikacije onda je članu iz mobilne aplikacije omogućen
        pregled pregled njegovog stanja, stanja zajednice, kao i pregled svih
        njegovih računa i transakcija.
      </h6>
      <h6>
        Povezivanje člana sa korisnikom blagajne se vrši prilikom kreiranja
        korisnika blagajne. Potrebno je iz polja za povezivanje sa stanarom
        izabrati člana zajednice kojeg želite da povežete.
      </h6>
      <h6>
        Ukoliko dodajete korisnike preko opcije grupnog dodavanja korisnika
        blagajne u toj listi se mogu naći svi članovi zajednice koji imaju Moj
        Komšija mobilnu aplikaciju. Svi korisnici koje kreirate ovim putem su
        povezani sa članovima koji imaju Moj Komšija mobilnu aplikaciju.
      </h6>-->
    </div>
    <div class="footer">
      <div class="buttons" style="text-align:center">
        <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Zatvori</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  methods: {
    ...mapMutations('modal', ['closeModal'])
  }
};
</script>

<style lang="scss" scoped>
.manual-wrapper {
  .body {
    height: 100%;
    width: 100%;
  }
  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }
}
</style>
